import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { withAuth } from "../components/Auth";
import Heading from "../components/Heading/Heading";
import Layout from "../components/Layout/Layout";
import Diagram from "../components/Diagram";

export class RoadmapPage extends Component {
  render() {
    return (
      <Layout showClouds>
        <Heading level={1} modifiers={["major"]}>
          RoadMap
        </Heading>
        <div className="card cms-content">
          <div class="card-collapse">
            <details class="warning" open>
              <summary>Instructions</summary>
              <p>
                Here is a small overview to what me and my Cloudbuddies are
                focussing upon.
              </p>
            </details>
          </div>

          <div class="card-collapse">
            <details class="info">
              <summary>Global</summary>
              <p>
                <ul>
                  <li>Single Sign On (Work in progress) </li>
                  <li>Improved Cloud Architecture Recommendations</li>
                  <li>Improved Chatflows</li>
                  <li>Improved two factor Authentication</li>
                  <li>Multi Cloud Platform Support</li>
                  <li>French & Spanish Version</li>
                </ul>
              </p>
            </details>
          </div>

          <div class="card-collapse">
            <details class="info">
              <summary>Amazon Web Services</summary>
              <p>
                <ul>
                  <li>
                    Identity and User Management: Users, Groups, Roles, Policies
                  </li>
                  <li>
                    Compute: Load Balancers, Kubernetes Clusters, Containers
                    Images
                  </li>
                  <li>
                    Applications Stacks: 2-Tiers, 3-Tiers, Static Website and
                    CDN
                  </li>
                  <li>Storage: Improved S3 Buckets</li>
                </ul>
              </p>
            </details>
          </div>

          <div class="card-collapse">
            <details class="info">
              <summary>Google Cloud Platform</summary>
              <p>
                <ul>
                  <li>Landing Zones</li>
                  <li>Host and Shared Projects</li>
                </ul>
              </p>
            </details>
          </div>

          <div class="card-collapse">
            <details class="info">
              <summary>Microsoft Azure</summary>
              <p>
                <ul>
                  <li>Stay tuned!</li>
                </ul>
              </p>
            </details>
          </div>
        </div>
      </Layout>
    );
  }
}

RoadmapPage.propTypes = {
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

export default withAuth(connect(mapStateToProps)(RoadmapPage));
